import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import AbstractMuteEveryonesVideoDialog, { abstractMapStateToProps } from '../AbstractMuteEveryonesVideoDialog';
/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before disabling all remote participants cameras.
 *
 * @augments AbstractMuteEveryonesVideoDialog
 */
class MuteEveryonesVideoDialog extends AbstractMuteEveryonesVideoDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.muteParticipantsVideoButton' }, cancel: { translationKey: 'menuController.cancel' }, onSubmit: this._onSubmit, title: this.props.title },
            React.createElement("div", { className: 'mute-dialog' }, this.state.content)));
    }
}
export default translate(connect(abstractMapStateToProps)(MuteEveryonesVideoDialog));
